<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                  
                   @refresh-change="onLoad"
        >
        <template slot="menu" slot-scope="scope">
                              <el-button
                                type="text"
                                size="small"
                                icon="el-icon-delete"
                                @click="stop(scope.row)"
                              >停用
                              </el-button> 
        </template>

          <template slot="tableLabel" slot-scope="row">
            <span><span style="color: red;">*&nbsp;</span>配置参数:&nbsp;&nbsp;</span>
          </template>
          <template slot="tableForm" slot-scope="scope">
            

            <avue-crud :data="paramData"
                       :before-open="addBeforeOpen"
                       :option="viewOption">
                       <template slot="menuLeft">
                           <el-button type="primary" v-if="!disabled" size="small" icon="el-icon-plus" @click="addFormData()">新 增
                           </el-button>
                       </template>
                          <!-- @input="e=>mappingParamNameInput(e,scope.row)" -->
                       <template slot="mappingParamName"  slot-scope="scope">
                         <el-input
                         :disabled="disabled"
                          v-model="scope.row.mappingParamName"
                          maxlength="20"
                          show-word-limit
                         ></el-input>
                       </template>
                       <template slot="measuringFlag" slot-scope="scope">
                          <el-switch
                            v-model="scope.row.measuringFlag"
                            active-color="#13ce66"
                             :disabled="disabled"
                            @change="changeMeasuringFlag(scope.row.temId)"
                            inactive-color="#ff4949">
                          </el-switch>
                       </template>
                            <template slot="paramId" slot-scope="scope">
                              <el-select 
                              v-model="scope.row.paramId"
                              :disabled="disabled"
                              @change="e=>changeParams(e,scope.row)"

                                >
                                  <el-option
                                    v-for="item in paramList"
                                    :key="item"
                                    :label="item.name"
                                    :value="item.id"
                                  >

                                  </el-option>
                              </el-select>
                            </template>
                            <template slot="menu" slot-scope="scope">
                              <el-button
                                type="text"
                                size="small"
                                icon="el-icon-delete"
                                v-if="!disabled"
                                @click="paramsDel(scope.row.temId)"
                              >删除
                              </el-button>
                            </template>
            </avue-crud>
          </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add,stop, getDetail, getList, remove, update,getParamsList,getParamsByparamId,getParamsDetailById} from "@/api/crmedical/energy/energymetermodel";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
              addFormDataFlag:true,
              disabled:false,
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                paramData:[],
                paramList:[],
                option: {
                  height: 'auto',
                  calcHeight: 50,
                  tip: false,
                  border: true,
                  index: true,
                  indexLabel: "序号",
                  viewBtn: true,
                  emptyBtnText:'重置',
                  selection: false,
                  delBtn: false,
                  searchMenuSpan: 6,
                  columnBtn: false,
                  refreshBtn: false,
                    column: [
                      {
                        label: "主键",
                        prop: "id",
                        editDisplay: false,
                        addDisplay: false,
                        viewDisplay: false,
                        hide: true,
                      },


                      {
                        label: "品牌名称",
                        prop: "brand",
                        maxlength: 32,
                        showWordLimit: true,
                        overHidden: true,
                        search: true,
                        rules: [{
                          required: true,
                          message: "请输入品牌名称",
                          trigger: "blur"
                        }]
                      },
                      {
                        label: "仪表类型",
                        prop: "meterType",
                        type: 'select',
                         search: true,
                        dataType: 'number',
                        dicUrl: 'api/blade-system/dict/dictionary?code=meter_type',
                        props: { label: 'dictValue', value: 'dictKey' },
                        rules: [{
                          required: true,
                          message: "请选择仪表类型",
                          trigger: "blur"
                        }]
                      },
                      {
                        label: "型号名称",
                        prop: "name",
                        maxlength: 32,
                        showWordLimit: true,
                        overHidden: true,
                        search: true,
                        rules: [{
                          required: true,
                          message: "请输入型号名称",
                          trigger: "blur"
                        }]
                      },
                      {
                        label: "计量参数",
                        prop: "paramName",
                        editDisplay: false,
                        addDisplay: false,
                        viewDisplay: false,
                      },
                      {
                        prop: 'table',
                        label: '',
                        formslot: true,
                        labelslot: true,
                        span: 24,
                        row:true,
                         hide: true,
                      },
                      {
                        label: "备注",
                        prop: "description",
                        type: 'textarea',
                        maxlength: 200,
                        showWordLimit: true,
                        overHidden: true,
                        span: 24,
                        row: 2,
                      },
                                                                        ]
                },
                viewOption: {

                calcHeight: 50,
               
                indexLabel: "序号",
                page: false,
                border: true,
                addBtn: false,
                selection: false,
                tip: false,
                columnBtn: false,
                refreshBtn: false,
                delBtn:false,
                editBtn:false,
                emptyBtnText:'重置',
                menuAlign: "center",
                menu: true,
                column: [
                  {
                    label: "仪表参数",
                    prop: "paramId",
                    type: 'select',
                    dataType: 'number',
                    slot:true
                  },
                  {
                    label: "参数编号",
                    prop: "paramCode",
                    maxlength: 200,
                    showWordLimit: true,
                    overHidden: true,
                  },
                  {
                    label: "计量单位",
                    prop: "measuringUnitName",
                  },
                  {
                    label: "映射参数名称",
                    slot:true,
                    prop: "mappingParamName",
                  },
                  {
                    label: "计量参数",
                    slot:true,
                    prop:'measuringFlag'
                  }
                ],
              },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.energymetermodel_add, false),
                    viewBtn: this.vaildData(this.permission.energymetermodel_view, false),
                    delBtn: this.vaildData(this.permission.energymetermodel_delete, false),
                    editBtn: this.vaildData(this.permission.energymetermodel_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        watch:{
          'form.meterType'(val){
            if(val){
              this.paramData=[];
              this.getParamsList();
            }
          }
        },
        methods: {
          // 选择计量参数
          changeMeasuringFlag(temId){
            this.paramData.forEach(ele=>{
              if(ele.temId == temId ){
                ele.measuringFlag = true;
              }else{
                ele.measuringFlag = false;
              }
            })
          },
          stop(row){
            this.$confirm("确定将选择数据停用?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        stop({id:row.id}).then(res=>{
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                          });
                          this.onLoad();
                      })
                    })
                    
          },
          // 删除
          paramsDel(temId){
            
            let temArr = [];
            console.log(temId)
            this.paramData.forEach((ele)=>{
              if(ele.temId != temId){
                temArr.push(ele);
              }
            })
            this.paramData = temArr;
            console.log(this.paramData)
            this.$forceUpdate();
          },
          // 获取详情
          getParamsDetailById(id){
            this.paramData= [];
            getParamsDetailById({modelId:id}).then(res=>{
              res.data.forEach(ele=>{
                ele.measuringFlag = ele.measuringFlag==1?true:false;
                res.data.forEach((ele,index)=>{
                  ele.temId = index+'tem0000';
                })
              })
              this.paramData = res.data;
            })
          },
          // 获取仪表参数下拉列表数据
          getParamsList(){
            getParamsList({meterType:this.form.meterType}).then(res=>{
              
              this.paramList = res.data;
            })
          },
          // 切换参数  更具仪表参数获取其他内容
          changeParams(val,row){
            
             getParamsByparamId({id:val}).then(({data})=>{
                row.paramId = val;
                row.paramCode = data.code,
                row.measuringUnitName=data.measuringUnitName,
                row.mappingParamName='';
                let temArr = [];
                this.paramData.forEach(ele=>{
                  temArr.push(ele);
                })
                this.paramData = temArr;
                this.$forceUpdate();
              //  this.paramData = Object.assign({},this.paramData,temOBj);
               console.log(this.paramData)
             })
          },
          // 新增
          addFormData(){
            if(this.paramData.length>0 && !this.paramData[this.paramData.length-1].paramId){
                this.$message({
                    message: '请先添加上一个仪表参数',
                    type: 'warning'
                });
                return;
            }
            if(!this.addFormDataFlag){
              return;
            }
            this.addFormDataFlag = false;
            setTimeout(()=>{
               let time1 = Date.parse(new Date());
                let temObj = {
                  temId:time1,
                  mappingParamName:'',
                  measuringFlag:false,
                }
                this.paramData.push(temObj);
                this.addFormDataFlag = true;
            },789)
           
          },
          addData(){
            console.log(!this.paramData[this.paramData.length-1].paramId)
            if(this.paramData.length>0 && !this.paramData[this.paramData.length-1].paramId){
                this.$message({
                    message: '请先添加上一个仪表参数',
                    type: 'warning'
                });
                return;
            }
            let obj = {
              mappingParamName:'',
            }
            
            this.paramData.push(obj)
          },
            rowSave(row, loading, done) {
                let temArr  = [];
                let flag = false;
                let mappingParamNameFlag = false;
                let paramIdFlag = false;
                if(this.paramData.length <1){
                  this.$message({
                    message: '请配置参数！',
                    type: 'warning'
                  });
                  done();
                  return;
                }
               
                this.paramData.forEach(ele=>{
                  
                  let temObj = {
                      mappingParamName:ele.mappingParamName,
                      measuringFlag:ele.measuringFlag?1:0,
                      measuringUnitName: ele.measuringUnitName,
                      paramCode: ele.paramCode,
                      paramId: ele.paramId,
                  };
                  if(!ele.paramId){
                    paramIdFlag = true;
                  }
                  if(ele.mappingParamName.length<1){
                    mappingParamNameFlag = true;
                  }
                  if(ele.measuringFlag){
                    flag = true;
                  }
                  
                  temArr.push(temObj);

                })
                if(paramIdFlag){
                   this.$message({
                    message: '请选择仪表参数',
                    type: 'warning'
                  });
                  done();
                  return;
                }
                if(mappingParamNameFlag){
                   this.$message({
                    message: '请输入映射参数名称',
                    type: 'warning'
                  });
                  done();
                  return;
                }
                if(!flag){
                  this.$message({
                    message: '请选择计量参数',
                    type: 'warning'
                  });
                  done();
                  return;
                }
                row.energyMeterModelParamList = temArr;
                add(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
              let temArr  = [];
              let flag = false;
              let paramIdFlag = false;
              let mappingParamNameFlag = false;
              if(this.paramData.length <1){
                this.$message({
                  message: '请配置参数！',
                  type: 'warning'
                });
                done();
                return;
              }
              this.paramData.forEach(ele=>{
                let temObj = {

                  mappingParamName:ele.mappingParamName,
                  measuringFlag:ele.measuringFlag?1:0,
                  measuringUnitName: ele.measuringUnitName,
                  paramCode: ele.paramCode,
                  paramId: ele.paramId,
                  id:ele.id
                };
                if(ele.measuringFlag){
                  flag = true;
                }
                 if(!ele.paramId){
                    paramIdFlag = true;
                  }
                if(ele.mappingParamName.length<1){
                    mappingParamNameFlag = true;
                  }
                temArr.push(temObj);

              })
               if(paramIdFlag){
                   this.$message({
                    message: '请选择仪表参数',
                    type: 'warning'
                  });
                  done();
                  return;
                }
               if(mappingParamNameFlag){
                   this.$message({
                    message: '请输入映射参数名称',
                    type: 'warning'
                  });
                  done();
                  return;
                }
              if(!flag){
                this.$message({
                  message: '请选择计量参数',
                  type: 'warning'
                });
                done();
                return;
              }
              row.energyMeterModelParamList = temArr;
                update(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
               this.disabled = false;
               
                if (["edit", "view"].includes(type)) {
                    if(["view"].includes(type)){
                      this.disabled = true;
                    }
                   this.viewOption.menu = false;
                    this.getParamsDetailById(this.form.id);
                }else{
                  this.viewOption.menu = true;
                  this.form = {};
                  this.paramData = [];
                }

                done();
            },
          addBeforeOpen(done, type) {
            if (["edit", "view"].includes(type)) {
              getDetail({id:this.form.id}).then(({data}) => {
                this.form = data;
              });
            }else {

            }
            done();
          },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                 done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
